/**
 * WalkthroughContext.js
 *
 * Global context for the guided walkthrough.
 * Manages step index, run state, modal visibility, and localStorage persistence.
 */

import { createContext, useContext } from 'react';

export const WALKTHROUGH_LS_KEY = 'marketplace_walkthrough_completed';

export const WalkthroughStateContext = createContext({
  // State
  isRunning: false,
  stepIndex: 0,
  isCompleted: false,
  showWelcomeModal: false,
  showCompletionModal: false,
});

export const WalkthroughActionsContext = createContext({
  // Actions
  startTour: () => {},
  stopTour: () => {},
  skipTour: () => {},
  completeTour: () => {},
  resetTour: () => {},
  goToStep: () => {},
  handleJoyrideCallback: () => {},
  setShowWelcomeModal: () => {},
  setShowCompletionModal: () => {},
});

export const useWalkthroughState = () => useContext(WalkthroughStateContext);
export const useWalkthroughActions = () => useContext(WalkthroughActionsContext);

export const useWalkthrough = () => {
  const state = useContext(WalkthroughStateContext);
  const actions = useContext(WalkthroughActionsContext);
  return { ...state, ...actions };
};
